import { SetMetadata } from '@nestjs/common'

export const CRON_METADATA = 'CRON_METADATA'

export interface CronOptions {
	name: string
	schedule: string
	/** Appconfig key to get cron schedule from */
	appconfigScheduleKey?: string
}

export const Cron = (options: CronOptions): MethodDecorator => SetMetadata(CRON_METADATA, options)
